// extracted by mini-css-extract-plugin
module.exports = {"simpleDialog":"Dialogs_simpleDialog__39yV3","title":"Dialogs_title__3rluQ","actionsWrapper":"Dialogs_actionsWrapper__B72PC"};